module.exports = __webpack_public_path__ + "static/media/Pledge.da23f924.png";